/**
 * Kleine rekenregels voor bijvullen. Puur; getest in core/rules/subscriptionBuilder.test.ts.
 * Het rekenen met dozen en ritmes staat in core/rules/refillPlan.ts.
 */

/** "± 3 maanden" → 13, "± 6 weken" → 6. Onbekend → `null`. */
export function lastsWeeksOf(label?: string): number | null {
  const m = label?.match(/(\d+(?:[.,]\d+)?)\s*(maand|maanden|week|weken)/i)
  if (!m) return null
  const n = Number(m[1].replace(',', '.'))
  return /maand/i.test(m[2]) ? Math.round(n * 4.35) : Math.round(n)
}

/** Bij welke van de eerste `count` dozen het cadeau zit (1-based), of `null`. */
export const giftDeliveryIn = (giftEvery: number, count: number): number | null =>
  Number.isInteger(giftEvery) && giftEvery >= 1 && giftEvery <= count ? giftEvery : null
